export default "__VITE_ASSET__BX26kAKh__"